/**
 * DataTestAttrs add 'data-' HTML attributes to React components for testing.
 *
 * These attributes explicitly couple components with tests. This is often
 * less brittle than depending on traditional CSS selectors.
 */
export default interface DataTestAttrs {
  component?: string;
  element?: string;
  key?: string;
  index?: string;
}

export enum DataTestPropName {
  COMPONENT = 'data-test-component',
  ELEMENT = 'data-test-element',
  KEY = 'data-test-key',
  INDEX = 'data-test-index',
}

// DataTestAttrs with valid JSX prop keys.
export interface DataTestProps {
  [DataTestPropName.COMPONENT]?: string;
  [DataTestPropName.ELEMENT]?: string;
  [DataTestPropName.KEY]?: string;
  [DataTestPropName.INDEX]?: string;
}
